<template>
    <section class="section">
        <div class="container">
            <page-header title="Kunder">
                <button class="button is-primary mr-2" @click="openModal(null)">Opret</button>
                <b-dropdown position="is-bottom-left" v-if="$store.getters.isAdmin">
                    <template #trigger="">
                        <b-button
                            type="is-primary"
                            icon-right="file-download" />
                    </template>

                    <b-dropdown-item @click="customersExport('customers')">Kunder</b-dropdown-item>
                    <b-dropdown-item @click="customersExport('customers_with_contacts')">Kunder med kontaktpersoner</b-dropdown-item>
                </b-dropdown>

            </page-header>

            <div class="field">
                <input v-model="query" class="input"
                       placeholder="Søg efter kunder... "
                       type="search" @input="search()">
            </div>
            <table class="table is-fullwidth table-fixed">
                <thead>
                    <tr>
                        <th @click="onUpdateOrderBy('economic_id')" class="is-clickable" width="130px">Kunde nr.
                            <SortArrow :orderBy="orderBy" field="economic_id" :direction="direction"/>
                        </th>
                        <th @click="onUpdateOrderBy('name')" class="is-clickable" width="200px">Navn
                            <SortArrow :orderBy="orderBy" field="name" :direction="direction"/>
                        </th>
                        <th @click="onUpdateOrderBy('address')" class="is-clickable" width="200px">Adresse
                            <SortArrow :orderBy="orderBy" field="address" :direction="direction"/>
                        </th>
                        <th @click="onUpdateOrderBy('zipcode')" class="is-clickable" width="120px">Post nr.
                            <SortArrow :orderBy="orderBy" field="zipcode" :direction="direction"/>
                        </th>
                        <th @click="onUpdateOrderBy('city')" class="is-clickable" width="150px">By
                            <SortArrow :orderBy="orderBy" field="city" :direction="direction"/>
                        </th>
                        <th @click="onUpdateOrderBy('country')" class="is-clickable">Land
                            <SortArrow :orderBy="orderBy" field="country" :direction="direction"/>
                        </th>
                        <th></th>
                    </tr>
                </thead>
                <tbody v-if="!isFetching">
                    <tr v-for="customer in customers" :key="customer.id">
                        <td class="is-clickable" @click="openCustomer(customer.id)">{{ customer.economic_id }}</td>
                        <td class="is-clickable overflow-dots" @click="openCustomer(customer.id)">{{ customer.name }}</td>
                        <td class="is-clickable overflow-dots" @click="openCustomer(customer.id)">{{ customer.address }}</td>
                        <td class="is-clickable" @click="openCustomer(customer.id)">{{ customer.zipcode }}</td>
                        <td class="is-clickable overflow-dots" @click="openCustomer(customer.id)">{{ customer.city }}</td>
                        <td class="is-clickable overflow-dots" @click="openCustomer(customer.id)">{{ customer.country }}</td>
                        <td class="has-text-right">
                            <a class="button is-small" @click="openModal(customer)">
                                <span class="icon">
                                    <i class="fas fa-edit"></i>
                                </span>
                            </a>
                        </td>
                    </tr>
                </tbody>
                <tbody v-else>
                    <tr v-for="index in skeletonRows" :key="index">
                        <td class="is-clickable">
                            <b-skeleton :animated="true"></b-skeleton>
                        </td>
                        <td class="is-clickable">
                            <b-skeleton :animated="true"></b-skeleton>
                        </td>
                        <td class="is-clickable">
                            <b-skeleton :animated="true"></b-skeleton>
                        </td>
                        <td class="is-clickable">
                            <b-skeleton :animated="true"></b-skeleton>
                        </td>
                        <td class="is-clickable">
                            <b-skeleton :animated="true"></b-skeleton>
                        </td>
                        <td class="is-clickable">
                            <b-skeleton :animated="true"></b-skeleton>
                        </td>
                        <td class="edit has-text-right">
                            <span class="icon is-small">
                                <b-skeleton></b-skeleton>
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="mt-2" v-if="!isFetching">
                <b-pagination
                    v-model="currentPage"
                    :per-page="pagination.per_page"
                    :total="pagination.total"
                    @change="paginate"
                    order="is-right">
                </b-pagination>
            </div>
        </div>

        <modal
            :active="modalOpen"
            :customer="modalCustomer"
            @closed="closeModal"
            @updated="onModalUpdated"
        />
    </section>
</template>

<script>
import List from '@elems/list'
import PageHeader from '@elems/pageHeader'
import Modal from './CustomerModal'
import SortArrow from '@elems/SortArrow'
import debounce from 'lodash/debounce'

export default {
    components: {
        PageHeader,
        List,
        Modal,
        SortArrow,
    },

    data() {
        return {
            currentPage: 1,
            query: '',
            customers: [],
            pagination: { total: 0 },
            isFetching: false,
            modalOpen: false,
            modalCustomer: null,
            skeletonRows: 50,
            orderBy: null,
            direction: null,
        }
    },

    created() {
        let params = new URLSearchParams(window.location.search)
        this.query = params.get('q');
        this.orderBy = params.get('order-by');
        this.direction = params.get('direction');
        const page = params.get('page');
        this.currentPage = page && /^[1-9]\d*$/.test(page) ? parseInt(page) : 1;
        this.fetchCustomers();
    },

    methods: {
        toggleDirection() {
            this.direction = (this.direction === 'asc') ? 'desc' : 'asc';
        },
        onUpdateOrderBy(key) {
            this.toggleDirection();
            this.orderBy = key;
            this.fetchCustomers();
        },
        search: debounce(function () {
            this.currentPage = 1;
            this.fetchCustomers();
        }, 200),
        paginate(value) {
            this.currentPage = value;
            this.fetchCustomers();
        },
        fetchCustomers() {
            this.isFetching = true
            let params = {};

            if (this.query) params['q'] = this.query;
            if (this.currentPage > 1) params['page'] = this.currentPage;
            if (this.orderBy) params['order-by'] = this.orderBy;
            if (this.direction) params['direction'] = this.direction;

            this.$router.push({ path: '/customers', query: params })

            window.axios.get('/api/customers', { params })
                .then(({ data }) => {
                    this.customers = data.data
                    this.pagination = data.meta
                    this.isFetching = false
                })
                .catch(error => {
                    console.error(error)
                    this.isFetching = true
                });
        },
        openCustomer(id) {
            this.$router.push('/customers/' + id)
        },
        openModal(customer = null) {
            this.modalOpen = true
            this.modalCustomer = customer
        },
        onModalUpdated() {
            this.fetchCustomers();
        },
        closeModal() {
            this.modalOpen = false
            this.modalCustomer = null
        },
        customersExport(itemTypeKey) {
            const params = { itemTypeKey: itemTypeKey }
            window.axios.get('/api/customers/export', { params })
                .then((response) => {
                    this.downloadCsv(response);
                    this.$store.dispatch('setSuccess', 'Kunderne blev eksporteret');
                })
                .catch(error => {
                    this.$store.dispatch('setError', 'Der opstod en fejl')
                });
        },
        downloadCsv(response) {
            const url = window.URL.createObjectURL(new Blob(["\ufeff"+response.data]));
            const cd = response.headers['content-disposition'];
            let fileLink = document.createElement('a');
            fileLink.href = url;
            fileLink.setAttribute('download', cd.match(/filename=(.+)/)[1]);
            document.body.appendChild(fileLink);
            fileLink.click();
            fileLink.remove();
        },
    }
}
</script>

<style scoped>

</style>
